import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { UserManagementEffects, userManagementFeature } from './store';

export function provideUserManagementFeature(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideState(userManagementFeature),
    provideEffects(UserManagementEffects),
  ]);
}
